import Swiper, { Pagination } from 'swiper';

const selectors = {
  slider: '.js-hero-alt-slider',
  progressBar: '.js-hero-alt-slider-progress',
  pagination: '.js-hero-alt-slider-pagination',
};

const resetProgress = (bar) => {
  bar.style.animation = 'none';
  void bar.offsetWidth; //! Triggers Reflow don't delete that
  bar.style.animation = null;
};

const heroAltSlider = () => {
  const elem = document.querySelector(selectors.slider);
  const progressBar = document.querySelector(selectors.progressBar);

  if (!elem) return;

  const swiper = new Swiper(elem, {
    grabCursor: true,
    modules: [Pagination],
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: selectors.pagination,
      clickable: true,
      bulletClass: 'c-hero-alt__bullet',
      bulletActiveClass: 'c-hero-alt__bullet--active',
    },
  });

  if (!progressBar) return;

  progressBar.addEventListener('animationend', () => {
    swiper.slideNext();
    resetProgress(progressBar);
  });

  swiper.on('slideChange', () => resetProgress(progressBar));
};

export default heroAltSlider;
